module.exports = __webpack_public_path__ + "img/quit_close.417759d4.png";